import { CardsPagination } from './CardsPagination';

export type { TypeCardsPaginationProps } from './types';
export default CardsPagination;
